// Copyright (C) 2021 Bystronic Laser AG

export interface Paged<T> {
  results: T[];

  page: number;
  totalResults: number;
  totalPages: number;
}

export function emptyPaged<T>(): Paged<T> {
  return {
    results: [],

    page: 1,
    totalResults: 0,
    totalPages: 0,
  };
}
